module.exports = __webpack_public_path__ + "img/about-patent2.89a5b29.png";